import React, { useState } from "react";
import { FACheck, FAClose, FAIncorrect } from "../../../components/atoms/fontawesomeIcon/Fontawesome";

export default function ExplanationModal({
  txnAttempts,
  currentQuestion,
  hint,
}: any) {
  const [showExplanation, setShowExplanation] = useState(false);
  const [showResponse, setShowResponse] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const toggleHint = () => {
    setShowHint((prev) => !prev);
  };


  const closeModal = () => {
    setShowExplanation(false);
    setShowResponse(false);
    setShowHint(false);
  };

  return (
    <>
      {/* Show / Hide buttons */}
      {!hint && currentQuestion?.data?.explanation && (
        <>
          <button
            onClick={() => {
              setShowExplanation(true);
              setShowResponse(false);
            }}
            className="explanation-text"
          >
            Show Explanation
          </button>
        </>
      )}

      {!hint && (
        <button
          onClick={() => {
            setShowResponse(true);
            setShowExplanation(false);
          }}
          className="response-text"
        >
          Show Response
        </button>
      )}

      {hint && currentQuestion?.data?.hint && (
        <button className="hint-text" onClick={toggleHint}>
          Show Hint
        </button>
      )}

      {/* Overlay */}
      {(showExplanation || showResponse || showHint) && (
        <div
          className="overlay"
          onClick={closeModal}
        >
          {/* Slide-up modal */}
          <div
           className="slide-up-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-line" onClick={closeModal}></div>
            <button
              className="modal-close-btn"
              onClick={closeModal}
            >
              <FAClose size="lg" color="#000"/>
            </button>

            {/* Response Section */}
            {showResponse && (
              <>
                <h3>Response</h3>
                {txnAttempts?.length > 0 && (
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    {txnAttempts?.map((attempt: any, index: number) => (
                      <div key={attempt._id}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "15px",
                          }}
                        >
                          <strong>
                            {index === 0 ? "First" : "Second"} Attempt:
                          </strong>

                          {attempt?.options_picked?.length > 0 && (
                            <span style={{ color: "#471FBF", fontWeight: 600 }}>
                              Option(s) picked:{" "}
                              {attempt.options_picked.map(
                                (pickedId: any, idx: number) => {
                                  const selectedOption =
                                    currentQuestion?.data?.options?.find(
                                      (opt: any) => opt.option_id === pickedId
                                    );

                                  if (!selectedOption) return null;

                                  return (
                                    <span
                                      key={pickedId}
                                      style={{ marginRight: 8 }}
                                    >
                                      {selectedOption.image_endpoint ? (
                                        <img
                                          src={selectedOption.image_endpoint}
                                          alt={`Option ${idx + 1}`}
                                          className="response-image"
                                        />
                                      ) : (
                                        selectedOption.value
                                      )}
                                    </span>
                                  );
                                }
                              )}
                            </span>
                          )}

                          {attempt?.input_answer && (
                            <span style={{ color: "#471FBF", fontWeight: 600 }}>
                              {attempt?.input_answer || "-"}
                            </span>
                          )}

                          {attempt?.isCorrect ? (
                            <FACheck size="lg" color="#14CB12"/>
                          ) : (
                            <FAIncorrect size="lg" color="red"/>
                          )}
                        </div>
                      </div>
                    ))}
                  </ul>
                )}

                  <div style={{ marginTop: "10px", fontSize: "16px" }}>
                    <strong>
                      Correct Answer:{" "}
                      {currentQuestion?.question_type === "MCQ" || currentQuestion?.question_type === "MULTIPLE" ? (
                        <span style={{ color: "green" }}>
                          {(() => {
                            const answers =
                              currentQuestion?.data?.answers || [];

                            if (!answers.length) return null;

                            return answers.map((ansId: any, idx: number) => {
                              const selectedOption =
                                currentQuestion?.data?.options?.find(
                                  (opt: any) => opt.option_id === ansId
                                );

                              if (!selectedOption) return null;

                              return (
                                <span
                                  key={ansId}
                                  style={{ marginRight: "8px" }}
                                >
                                  {selectedOption.image_endpoint ? (
                                    <img
                                      src={selectedOption.image_endpoint}
                                      alt={`Option ${idx + 1}`}
                                      className="response-image"
                                    />
                                  ) : (
                                    selectedOption.value || null
                                  )}
                                </span>
                              );
                            });
                          })()}
                        </span>
                      ) : (
                        <span style={{ color: "green" }}>
                          {Array.isArray(currentQuestion?.data?.answers)
                            ? currentQuestion?.data?.answers.join(", ")
                            : currentQuestion?.data?.answers}
                        </span>
                      )}
                    </strong>
                  </div>
              </>
            )}

            {/* Explanation Section */}
            {showExplanation && currentQuestion?.data?.explanation && (
              <>
                <h3 style={{ marginTop: "16px" }}>Explanation</h3>
                <div dangerouslySetInnerHTML={{__html: currentQuestion?.data?.explanation}}/>
                {currentQuestion?.data?.e_image && (
                  <img
                    src={currentQuestion?.data?.e_image}
                    alt="Explanation"
                    className="explanation-img"
                  />
                )}
              </>
            )}

            {/* Hint Section */}
            {showHint && currentQuestion?.data?.hint && (
              <>
                <h3 style={{ marginTop: "16px" }}>Hint</h3>
                <div dangerouslySetInnerHTML={{__html: currentQuestion?.data?.hint}}/>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
